import React from 'react';
import { Drawer, Button } from '@mui/material';
import ChatContacts from './ChatContacts/ChatContacts';
import ConfigUser from './ConfigUser';
import MessageIcon from '@mui/icons-material/Message';  // Importamos el icono de mensaje
import SettingsIcon from '@mui/icons-material/Settings';

const ContactMobil = ({ openDrawer, setOpenDrawer, openConfi, setOpenConfig, isMobile, contacts, selectUser, userSystem, logout, userLoggedIn, loadingContactMessages, loadedContactIds, contactActive }) => {
    // Función para alternar el estado openConfig
    const handleOpenConfig = () => {
        setOpenConfig(openConfi => !openConfi); // Alterna el valor de openConfig
    };
    return (
        <Drawer
            anchor="left"
            open={openDrawer}
            onClose={() => setOpenDrawer(false)}
            sx={{
                display: isMobile ? 'block' : 'none', // Solo se muestra en móvil
                width: '250px',
                '& .MuiDrawer-paper': {
                    backgroundColor: '#111b21',
                    color: '#fff',
                    padding: 2,
                    width: '250px',
                },
            }}
        >
            {userLoggedIn ? (
                <Button
                    sx={{
                        backgroundColor: '#2a3c42',
                        color: '#fff',
                        padding: 1,
                        borderRadius: '50%',
                        minWidth: '0px',
                        minHeight: '0px',
                        boxShadow: 'none',
                        '&:hover': {
                            backgroundColor: '#375e67',
                        },
                        position: 'absolute',  // Asegura que el botón se quede en la parte inferior
                        top: 8,            // Se coloca 20px por encima del borde inferior
                        right: -8,           // Centrado horizontalmente
                        transform: 'translateX(-50%)', // Ajusta la posición centrada
                    }}
                    onClick={handleOpenConfig}
                >
                    {!openConfi ? (
                        <SettingsIcon />
                    ) : (
                        <MessageIcon />
                    )}
                </Button>
            ) : ""}
            {/* Contenedor de contactos */}
            {!openConfi ? (
                <ChatContacts contacts={contacts} selectUser={selectUser} isMobile={isMobile} loadingContactMessages={loadingContactMessages} loadedContactIds={loadedContactIds} contactActive={contactActive} userLoggedIn={userLoggedIn}/>
            ) : (
                <ConfigUser userSystem={userSystem} isMobile={isMobile} logout={logout} />
            )}
        </Drawer>
    );
};

export default ContactMobil;
